<template>
  <div class="relative rounded-xl">
    <div class="relative w-full">
      <div
        class="absolute inset-y-0 left-0 flex items-center pl-6 pointer-events-none"
      >
        <span class="text-gray-500 sm:text-sm sm:leading-5 tmsk-blue-border">
          (+65)
        </span>
      </div>
      <input
        id="mobileInput"
        type="tel"
        class="flex-1 block w-full py-2 pl-20 pr-10 text-gray-500 border rounded-full outline-none tmsk-blue-border sm:text-sm sm:leading-5"
        placeholder="Enter your mobile number"
        v-model="input"
        @keyup.enter="$emit('handle-enter')"
      />
    </div>

    <p v-if="!valid & dirty" class="pt-2 text-sm text-center text-red-600">
      {{ $t("verification.mobileNumber.input.invalid") }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'MobileNumberInput',
  components: {},
  mixins: [],
  props: {
    defaultValue: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      dirty: false,
      valid: false,
      input: ''
    }
  },
  computed: {
    // validationClasses () {
    //   if (this.valid) {
    //     return {
    //       prefix: 'text-green-500',
    //       input: 'border-green-300 text-green-500 placeholder-green-100 focus:border-green-300 focus:shadow-outline-green'
    //     }
    //   } else if (this.dirty && !this.valid) {
    //     return {
    //       prefix: 'text-red-600',
    //       input: 'border-red-300 text-red-600 placeholder-red-100 focus:border-red-300 focus:shadow-outline-red'
    //     }
    //   } else {
    //     return {
    //       prefix: 'text-gray-500 placeholder-gray-300 tmsk-blue-border',
    //       input: ''
    //     }
    //   }
    // }
  },
  watch: {
    input (newValue) {
      if (this.dirty || this.input.length > 7) {
        if (!this.dirty) this.dirty = true
        this.valid = this.validatePhoneNumber(newValue)
      }

      this.$emit('handleInput', newValue)
    },

    dirty (newValue) {
      if (newValue) {
        this.valid = this.validatePhoneNumber(this.input)
      }
    },

    valid (newValue) {
      this.$emit('handleValid', newValue)
    }
  },

  // Lifecycle Hooks
  beforeCreate () {},
  created () {},
  beforeMount () {},
  mounted () {
    if (this.defaultValue) {
      this.input = this.defaultValue
    } else {
      const input = document.querySelector('#mobileInput')
      input.focus()
      input.addEventListener('blur', () => {
        this.dirty = true
      }, { once: true })
    }
  },
  beforeUpdate () {},
  updated () {},
  beforeDestroy () {},
  destroyed () {},
  methods: {
    validatePhoneNumber (input) {
      const regex = /^[89]\d{7}$/
      return regex.test(input)
    }
  }
}
</script>

<style scoped>
</style>
